import React from 'react';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconClose from '../../../assets/icons/icon_close.svg';

export default function ModalMotivoRechazo({ motivoRechazo, modalIsVisible, handleClose }) {


  return (
    <SmallModalContainer open={modalIsVisible} onClose={handleClose}>
      <Box
        component="img"
        sx={{
          width: '24px', height: '24px', cursor: 'pointer', position: 'absolute',
          top: '1rem',
          right: '1rem'
        }}
        alt="img not found"
        src={iconClose}
        onClick={handleClose}
      />
      <Typography
        id="detalles"
        variant="h2"
        sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '0.5rem' }}>
        {motivoRechazo?.descripcion}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginTop: '1rem',
          gap: '1rem'
        }}>
        <Typography variant="h5">{motivoRechazo?.mensaje}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          marginTop: '2rem',
          justifyContent: 'center'
        }}>
        <Button
          sx={{ width: '372px', height: '3rem', borderRadius: '1rem' }}
          variant="contained"
          onClick={handleClose}
          color="primary">
          Entendido
        </Button>
      </Box>
    </SmallModalContainer>
  );
}
